export default __webpack_public_path__ + "static/media/480_dummy2016-massagestudio01-mobile-de.53332d78.png";